import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { HelpersService } from "../shared/helpers-service/helpers.service";

@Component({
    selector: "wk-access-unauthorized",
    templateUrl: "./access-unauthorized.component.html",
    styleUrl: "./access-unauthorized.component.scss",
    standalone: false,
})
export class AccessUnauthorizedComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private translateService = inject(TranslateService);
    private helpersService = inject(HelpersService);

    constructor() {}

    ngOnInit(): void {
        const lang = this.route.snapshot.params["lang"];
        if (lang) {
            this.translateService.use(lang);
        }
        this.helpersService.noUdsNavigationEmitter.next(null);
    }
}
